import { useState } from 'react';

interface Product {
  id: number;
  name: string;
  genericName: string;
  image: string;
  category: string;
  isNew?: boolean;
  description: string;
}

export default function Products() {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  const products: Product[] = [
    {
      id: 1,
      name: 'NITRODIL',
      genericName: 'Nitroglycerin 2.6 Tab',
      image: '/assets/productHome/001.jpg',
      category: 'Cholesterol Management',
      isNew: true,
      description: 'A potent Vasodilator\nUsed in Angina pectoris\nHeart Attack\nHypertensive Crises.'
    },
    {
      id: 2,
      name: 'NESDIL',
      genericName: 'Nicrorandil 10mg Tab',
      image: '/assets/productHome/002.jpg',
      category: 'Hypertension Control',
      description: 'Shows Anti-Ischemic & Cardioprotective Benefits for a wide Range of Coronary Artery Disease \nPatients with different risk factors.'
    },
    {
      id: 3,
      name: 'MESTA XL',
      genericName: 'Metoprolol 50mg Tab',
      image: '/assets/productHome/003.jpg',
      category: 'Antiplatelet Therapy',
      description: 'Used in Hypertension \nAngina pectoris\nSupravantricular Tacchycardia.'
    },
    {
      id: 4,
      name: 'TELMISUN',
      genericName: 'Telmisartan 40mg Tab',
      image: '/assets/productHome/004.jpg',
      category: 'Beta Blocker',
      description: 'Used in Early Hypertension \nEdema in Hypertensives'
    },
    {
      id: 5,
      name: 'ROZUNEW GOLD',
      genericName: 'Rosuvastatin 10mg + Chlopidogrel 75mg + Aspirin 75mg',
      image: '/assets/productHome/005.jpg',
      category: 'Anticoagulant',
      description: 'Primary Hypercholesterolemia \nDyslipidemia\nCoronary Heart Disease'
    },
    {
      id: 6,
      name: 'SACCUDIL 50',
      genericName: 'Saccubitril 24/51 + Valsartin 26/49',
      image: '/assets/productHome/006.jpg',
      category: 'Vasodilator',
      description: 'For the treatment of Heart Failure\nReduces Risk of Hospitalization\nImproves survival rate'
    },
    {
      id: 7,
      name: 'DAPAFILL 10',
      genericName: 'Dapagliflozin 10mg',
      image: '/assets/productHome/007.jpg',
      category: 'Diuretic',
      description: 'Patients With Diabetes are at high risk for adverse outcomes from Atherosclerosis Crdiovascular Disease Heart Failure and renal Disease.'
    },
    {
      id: 8,
      name: 'ESGLIM M1',
      genericName: 'Glimipiride 1mg + Metformin 500mg SR Tab',
      image: '/assets/productHome/008.jpg',
      category: 'ACE Inhibitor',
      description: 'An OAD that provides Good Glycemic Control Including A1C,PPG,and FASTING.'
    },
    {
      id: 9,
      name: 'TELMISUN-AM',
      genericName: 'Telmisartan 40mg + Amlodipine 5mg Tab',
      image: '/assets/productHome/009.jpg',
      category: 'Cardiac Glycoside',
      description: 'A Antihypertensive combination.\nControls BP reduces Cardiovascular Events.'
    },
    {
      id: 10,
      name: 'TELMISUN-CH',
      genericName: 'Telmisartan 40mg + Chlorthalidone 12.5mg Tab',
      image: '/assets/productHome/010.jpg',
      category: 'Lipid Lowering',
      description: 'Where Hypertension is not controlled with Monotherapy'
    }
  ];

  return (
    <section id="products" className="py-24 pb-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Our Cardiovascular Portfolio 💙
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A comprehensive range of specialized cardiac medications designed to address various cardiovascular conditions with proven efficacy and safety.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8" data-product-shop>
          {products.map((product) => (
            <div
              key={product.id}
              className="group bg-white rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-200 hover:border-blue-400 cursor-pointer relative"
              onClick={() => setSelectedProduct(product)}
            >
              {product.isNew && (
                <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full z-10 shadow-lg">
                  NEW
                </div>
              )}
              <div className="h-40 p-4 flex items-center justify-center bg-gradient-to-br from-blue-50 to-white">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-5 border-t border-gray-100">
                <h3 className="text-base font-bold text-gray-900 mb-1.5">{product.name}</h3>
                <p className="text-sm text-gray-600 mb-3 font-medium">{product.genericName}</p>
                {/* <span className="inline-block bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1.5 rounded-lg border border-blue-200">
                  {product.category}
                </span> */}
                <div className="opacity-0 group-hover:opacity-100 transition-opacity mt-4">
                  <span className="text-blue-600 text-sm font-semibold flex items-center">
                    View Details
                    <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedProduct && (
        <div
          className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedProduct(null)}
        >
          <div
            className="bg-white rounded-2xl max-w-4xl w-full p-10 relative shadow-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedProduct(null)}
              className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <div className="grid md:grid-cols-2 gap-10">
              <div className="flex items-center justify-center bg-gradient-to-br from-blue-50 to-white rounded-xl p-8 border border-gray-200">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.name}
                  className="w-full h-auto object-contain"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-3">{selectedProduct.name}</h3>
                <p className="text-xl text-gray-700 mb-5 font-medium">{selectedProduct.genericName}</p>
                <div className="mb-6">
                  {/* <span className="inline-block bg-blue-50 text-blue-700 text-sm font-semibold px-4 py-2 rounded-lg border border-blue-200">
                    {selectedProduct.category}
                  </span> */}
                </div>

                <p className="text-gray-600 text-base leading-relaxed mb-6">
                  {selectedProduct.description.split('\n').map((line, index) => (
                    <span key={index}>
                      {line}
                      <br />
                    </span>
                  ))}
                </p>
                <div className="bg-blue-50 p-5 rounded-xl border border-blue-200 mt-8">
                  <p className="text-sm text-blue-900 font-semibold flex items-start">
                    <i className="ri-information-line mr-2 mt-0.5 text-lg"></i>
                    <span>Prescription medication - Available through authorized healthcare providers</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}